import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: black;
  font-weight: 600;
  & > span {
    font-size: 3em;
    margin-bottom: 1rem;
  }
`;

export const GPS = styled.div`
  position: fixed;
  top: 30px;
  right: 0;
`;

export const Retry = styled.button`
  padding: 10px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  color: white;
  background: rgb(230, 158, 33);
  border: 0;
`;
